import { tabAccessControl } from "../../../_helpers/access-control";

let SuppliersTabs = [
  {
    text: "All",
    path: `/supplier`,
    applicationFeatureCode: "Supplier",
  },
  {
    text: "Transactions",
    path: `/supplier-transaction`,
    applicationFeatureCode: "SupplierTransactionHistory",
  },
  {
    text: "Awaiting Payments",
    path: `/supplier/awaiting-payment-list`,
    applicationFeatureCode: "SupplierTransactions",
  },
  {
    text: "Batch Payments",
    path: `/supplier/batch-payment-list`,
    applicationFeatureCode: ["BatchPaymentCommit", "BatchPaymentSave"],
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(SuppliersTabs).findIndex((x) => x.text == tabName);
}

export { SuppliersTabs, GetIndexByTabName };
